import { Dropdown, DropdownSizes } from '@inno-ui/dropdown'
import type { DropdownOption, DropdownValue } from '@inno-ui/dropdown'
import { useWallpaperStore } from 'shared/stores/wallpaperStore'

import styles from './SeasonPreview.module.scss'

const options: DropdownOption[] = [
  { value: 'automatic', label: 'Automatic (current season)' },
  { value: 'spring', label: 'Spring' },
  { value: 'summer', label: 'Summer' },
  { value: 'autumn', label: 'Fall' },
  { value: 'winter', label: 'Winter' }
]

export const SeasonPreview = () => {
  // This component mounts only for seasonal wallpapers in testing environments.
  const value = useWallpaperStore(state => state.seasonPreview)
  const onChange = useWallpaperStore(state => state.setSeasonPreview)
  const handleChange = (selection: DropdownValue) => {
    const season =
      typeof selection === 'string'
        ? selection
        : selection && !Array.isArray(selection)
          ? selection.value
          : undefined
    if (season === 'automatic') onChange(null)
    else if (
      season === 'spring' ||
      season === 'summer' ||
      season === 'autumn' ||
      season === 'winter'
    )
      onChange(season)
  }

  return (
    <div className={styles.preview}>
      <Dropdown
        label='Season preview · Testing only'
        items={options}
        value={options.find(option => option.value === (value ?? 'automatic'))}
        onChange={handleChange}
        size={DropdownSizes.S}
        width='100%'
        portal
      />
    </div>
  )
}
